
import React from 'react';
import { PopupContext } from "./PopupContext";
import {getRGB, multBlack, multWhite} from "../../../lib/color";
import {deep_copy} from "../../../lib/js-utils";

class OptionPopupMenu extends React.Component {

  static contextType = PopupContext;

  constructor(props) {
    super(props);
    this.state = {
      mouse_over_id: "",
    }
  }

  onMouseOver = (id, mouse_over) => ev => {
    if (mouse_over) {
      this.setState({mouse_over_id: id });
    } else if (this.state.mouse_over_id === id) {
      this.setState({ mouse_over_id: "" });
    }
  };

  onClick = button_id => () => {
    const button = this.props.buttons.find(button => button.id === button_id);

    if (!button) {
      return;
    }

    if (button.disable) {
      return;
    }

    if (this.context && this.context.onMouseOver) {
      this.context.onMouseOver(this.props.menu_id, false)();
    }
    if (this.context && this.context.onPopupMenuClick) {
      this.context.onPopupMenuClick(this.props.menu_id, button_id);
    }
  }

  gen_button_style = (button_id, disable) => {
    const style = {
      ...this.props.style,
    }
    const colors = this.props.client && this.props.client.color;

    if (!colors) {
      return style;
    }

    style.backgroundColor = deep_copy(colors.background);
    style.color = deep_copy(colors.text);

    if (colors.mode === "dark") {
      style.backgroundColor = multWhite(
        style.backgroundColor,
        (this.state.mouse_over_id === button_id && !disable)
          ? 0.2 : 0.0);
      if (disable) {
        style.color = multBlack(style.text, 0.7);
      }
    } else if (colors.mode === "light") {
      style.backgroundColor = multBlack(
        style.backgroundColor,
        (this.state.mouse_over_id === button_id && !disable)
          ? 0.9 : 1.0);
      if (disable) {
        style.color = multWhite(style.color, 0.6);
      }
    }

    style.backgroundColor = getRGB(style.backgroundColor);
    style.color = getRGB(style.color);
    return style;
  }

  render = () => {
    const colors = this.props.client && this.props.client.color;
    const style = {
      textAlign: "left",
      pointerEvents: "auto",
    };

    if (colors) {
      style.backgroundColor = getRGB(colors.background);
      style.color = getRGB(colors.text);
    }

    const buttons = this.props.buttons || [];

    return (
      <div style={style}>
        { buttons.map(button => {
          return (
            <div
              onMouseOver={this.onMouseOver(button.id, true)}
              onMouseOut={this.onMouseOver(button.id, false)}
              onClick={this.onClick(button.id)}
              style={this.gen_button_style(button.id, button.disable)}
              key={button.id}>
              <span>{button.label}</span>
            </div>
          )
        })}
      </div>
    )
  }
}

export { OptionPopupMenu };
